import React from 'react';
import { Card, Button, Tooltip, Spin, Tag, Empty, Typography } from 'antd';
import { ReloadOutlined, RightOutlined, UserOutlined, ClockCircleOutlined, CommentOutlined, MoreOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { CommunityNewsItem } from '../../services/dashboardService';

const { Text } = Typography;

interface CommunityNewsCardProps {
    news: CommunityNewsItem[];
    onRefresh: () => void;
    loading: boolean;
}

export const CommunityNewsCard: React.FC<CommunityNewsCardProps> = ({
    news,
    onRefresh,
    loading,
}) => {
    const navigate = useNavigate();

    const handleViewMore = () => {
        navigate('/community-posts');
    };

    return (
        <Card
            className="dashboard-card community-news-card"
            title={
                <div className="news-card-header">
                    <div className="news-title-wrap">
                        <CommentOutlined className="news-fire-icon" style={{ color: '#1890ff' }} />
                        <span>跨境社区热帖</span>
                    </div>
                    <div className="news-controls">
                        <Tooltip title="刷新">
                            <Button
                                type="text"
                                size="small"
                                icon={<ReloadOutlined spin={loading} />}
                                onClick={onRefresh}
                            />
                        </Tooltip>
                    </div>
                </div>
            }
        >
            {loading ? (
                <div className="news-loading">
                    <Spin />
                </div>
            ) : news.length > 0 ? (
                <div className="news-list">
                    {news.slice(0, 10).map((item, index) => (
                        <a
                            key={index}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="news-item"
                        >
                            <div className="news-item-content">
                                <div className="news-item-title" style={{ fontSize: 13 }}>{item.title}</div>
                                <div className="news-item-meta">
                                    <Text type="secondary" style={{ fontSize: 11 }}>
                                        <UserOutlined style={{ marginRight: 4 }} />
                                        {item.author}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 11, marginLeft: 12 }}>
                                        <ClockCircleOutlined style={{ marginRight: 4 }} />
                                        {item.time}
                                    </Text>
                                </div>
                            </div>
                            <RightOutlined className="news-item-arrow" />
                        </a>
                    ))}
                </div>
            ) : (
                <Empty description="暂无热帖" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            <div className="news-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Text type="secondary" style={{ fontSize: 11 }}>
                    来源: 知无不言 wearesellers.com
                </Text>
                <Button
                    type="link"
                    size="small"
                    onClick={handleViewMore}
                    style={{ padding: 0, fontSize: 12 }}
                    icon={<MoreOutlined />}
                >
                    查看更多
                </Button>
            </div>
        </Card>
    );
};
